import axios from 'utils/axios';

export const updateDailyConclusionStrategy = (params?: any) => {
  const { id } = params || {};
  return axios.put(`/api/v1/dailyconclusionstrategies/${id}`, params);
};
